module.exports = __webpack_public_path__ + "static/media/img-multi-sig-wallet-new.36b1bbe2.pdf";